/**
 * Created by agung<agung.julisman@yahoo.com> on 05/10/15.
 * Improved by Adhitama Fikri <adhitamafikri@gmail.com> on 16/12/19 to use APIOrderSDK for carts
 */
app.controller('itemVendorCtrl', ['Server', '$scope', 'growl', '$location', 'Socialshare', 'ItemQuantity', '$filter', '$translate', '$timeout', '$window', 'encodeService', 'Cookie', 'APIOrderSDK', 'APIOrderSDKV2', '$http', 'permissionService', 'googleAnalytics4', 'Path', function (Server, $scope, growl, $location, Socialshare, ItemQuantity, $filter, $translate, $timeout, $window, encodeService, Cookie, APIOrderSDK, APIOrderSDKV2, $http, permissionService, googleAnalytics4, Path) {
    /*
     * init parent data
     **/
    $scope.home.pageClass = 'item-vendor';

    /*
    * global object
    * */
    var self = this;
    self.seller = rawProduct.seller;
    
    // Store Withdraw
    if (self.seller && self.seller.vendor_status === 'W') angular.element('#infoWithdrawStoreModal').modal({ show: true, backdrop: 'static', keyboard: false });
    self.closeInfoWithdrawStoreModal = function () {
        angular.element('#infoWithdrawStoreModal').modal('hide');
        window.open(url('permintaan-penawaran/form'), '_blank');
    }
    // End Store Withdraw
    
    bodyDOM = document.querySelector('body');
    self.initializeProduct = function (home, product) {

        home.noHeader = false;
        home.noFooter = false;
        home.bodyBgGray = true;

        self.product = product;
        self.product.seo.url = $location.absUrl();

        calcInitPrice();
        generateSimulation();
        checkShowParam();
        initZoom();
        getItemSlide();

        if (self.product.seller.schedule.is_open === 'N') {
            var tempOpen = fecha.parse(self.product.seller.schedule.end_date, 'YYYY-MM-DD');
            tempOpen = new Date(tempOpen.setDate(tempOpen.getDate() + 1));
            self.product.seller.schedule.start_date = fecha.format(fecha.parse(self.product.seller.schedule.start_date, 'YYYY-MM-DD'), 'D MMMM YYYY');
            self.product.seller.schedule.end_date = fecha.format(tempOpen, 'D MMMM YYYY');
        }

        vendoralias = angular.copy(self.product.seller.url);
        parentId = angular.copy(self.product.item.parent_id);
        self.quantity = self.product.availability.minimum_order;
        self.url = '/items/vendor-item-filter/' + vendoralias + '?parent_id=' + parentId;
        self.questions = [];
        self.newQuestion = '';
        self.productName = self.product.item.name.replace(/&amp;/g, "&");
        self.debounce = 1000;
        self.quantity_update = null;
        self.countdown = countdown;

        $scope.$parent.pageName = self.productName.replace(/&amp;/g, "&"); // For dynamic title in breadcrumb

        // check browser support for localStorage and sessionStorage
        if (typeof(Storage) !== "undefined" && self.product.item.id) {
            var productsLastSeen = localStorage.getItem('productsLastSeen');
            if (productsLastSeen) {
                productsLastSeen = JSON.parse(productsLastSeen);
                if (productsLastSeen.length) {
                    var find = _.find(productsLastSeen, function (v, k) {
                        if (v === self.product.item.id) {
                            productsLastSeen.splice(k, 1);
                            return v === self.product.item.id;
                        }
                    });

                    if (!find && productsLastSeen.length >= 6) productsLastSeen.pop();

                    productsLastSeen.unshift(self.product.item.id);
                    localStorage.setItem('productsLastSeen', JSON.stringify(productsLastSeen));
                }
            } else {
                var productsLastSeen = [];
                productsLastSeen.push(self.product.item.id);
                localStorage.setItem('productsLastSeen', JSON.stringify(productsLastSeen));
            }
        } else {
            console.warn('Sorry! No Web Storage support..');
        }

        // Reverse wholesale price data to display lowest price first
        if (self.product.price_type === 'wholesale') {
            self.product.prices.reverse();
        }

        if (self.product.campaign) {
            self.product.campaign.campaign_prices.reverse();
        }


        $scope.unit_item = [
            {value: 'Unit', name: 'Unit'},
            {value: 'Liter', name: 'Liter'},
            {value: 'Box', name: 'Box'},
            {value: 'Meter', name: 'Meter'},
            {value: 'Roll', name: 'Roll'},
            {value: 'Lusin', name: 'Lusin'},
            {value: 'Set', name: 'Set'}
        ];

        self.rfq.quantity = parseInt(self.product.availability.minimum_order);
        self.rfq.price = Number(self.product.prices[0].price);
        self.showChat = (self.product.seller.id !== userid);

        let item = {
            item_id: self.product.item.id.toString(),
            item_name: self.product.item.name,
            affiliation: 'Product SKU',
            coupon: '',
            currency: 'IDR',
            discount: self.product.price.original - self.product.price.value,
            item_brand: self.product.brand.name,
            item_category: self.product.categories[0].name,
            item_category2: self.product.categories[1].name,
            item_list_id: '',
            item_list_name: '',
            item_variant: self.product.variances ? self.product.variances.default.model.name : '',
            location_id: '',
            price: self.product.price.original,
        }
        if (self.product.availability.stock_type === 'finite') {
            item.quantity =  self.product.price.stock
        }
        googleAnalytics4.trackViewItem([item])
    };


    /*set object for quotation */
    self.quotation = {};
    self.cart = {};
    self.data = {};

    self.textWishlist = 'Tambahkan ke Wishlist';
    self.cached = false;
    self.alert = true;
    self.hideAddToCart = true;
    self.alertMinOrder = false;
    self.defaultModel = '';
    self.shareUrl = $location.absUrl();

    self.outOfStock = function () {
        if (self.product.item.inventory_type === 'finite') {
            if (self.product.item.available_stock === 0) {
                self.alert = false;
                self.quantity = 0;
                self.hideAddToCart = false;
                return true;
            } else if (self.product.price_type !== 'retail' && self.product.price_type !== 'wholesale') {
                self.hideAddToCart = false;
                self.quantity = 0;
                return true;
            } else if(self.product.availability.is_campaign_available == false && self.product.availability.stock_available && self.product.availability.stock_quantity < self.product.availability.minimum_order) {
                self.alert = false;
                self.alertMinOrder = true;
                self.quantity = self.product.availability.minimum_order;
                self.hideAddToCart = false;
                return true;
            }
        } else {
            if (self.product.price_type === 'marketplace') {
                self.hideAddToCart = false;
                self.quantity = 0;
                return false;
            } else if (self.product.price_type !== 'retail' && self.product.price_type !== 'wholesale' && self.product.price_type !== 'location') {
                self.hideAddToCart = false;
                self.quantity = 0;
                return true;
            }
        }
    };

    self.userOnline = [];
    self.is_login = is_login;
    self.simulations = [];
    self.isDisabled = false;

    function capitalizedWords(str){
        return str.replace(/(\w)(\S*)/ig, function(match, p1, p2){
            return p1.toUpperCase() + p2;
        })
    }

    $scope.$watch(function () {
        return $scope.home.homecart;
    }, function (newVal, oldVal) {
        if (newVal) {
            self.isDisabled = true;
            checkItemLocationCart();
        }
    });

    function getItemSlide () {

        Server.getDataFromServer('/items/vendor-item-related-vendor/' + self.product.seller.url + '?alias=' + self.product.item.alias).then(function (data) {
            self.itemCompared = data.result;
        });

        Server.getDataFromServer('/items/vendor-item-related-categories?alias=' + self.product.item.alias).then(function (data) {
            if (data.result !== null) {
                self.itemRelated = data.result;
                self.titleID = "related_product";
            }
        });

    }

    if (is_login) {
        permissionService.checkPermissionList()
    }
    
    self.openContactSellerModal = function () {
        if (!permissionService.hasPermission('website.chat_seller')) return;
        
        $scope.home.isLoading = true;
        return Server.getDataFromServer('/microsite/profile-chat/'+self.product.seller.id)
        .then(function(response) {
            if(self.is_login){
                var item_url = base_path+'/v/'+self.product.seller.url+'/product/'+self.product.item.alias;
                var item_image = self.product.images.length === 0 ? (image_path + 'assets/img/no-image.png') :self.product.images[0].thumbnail;
                localStorage.setItem('chatItemUrl', item_url);
                localStorage.setItem('chatItemImage', item_image);
                localStorage.setItem('itemId', self.product.item.id);
                window.location = '/customer/chat/history/'+response.result.encoded_key;
            }else{
                window.location = 'login';
            }
        });
    }

    self.openContactSellerModalNew = function () {
        if (!permissionService.hasPermission('website.chat_seller')) return;
        
        $scope.home.isLoading = true;
        return Server.getDataFromServer('/microsite/profile-chat/'+self.product.seller.id)
        .then(function(response) {
            if(self.is_login){
                const item_image = self.product.images.length === 0 ? (image_path + 'assets/img/no-image.png') :self.product.images[0].thumbnail;
                const productDetail = { 
                    itemImg: item_image,
                    itemName: self.product?.item?.name,
                    itemAlias: self.product?.item?.alias,
                    itemPrice: self.product?.price?.value,
                    vendorId: String(self.seller.id),
                    vendorAlias: self.seller.url,
                }
                localStorage.setItem('itemDetails', JSON.stringify(productDetail))
                if ($scope.home.screenType === 'mobile') {
                    return window.location = process.env.WEB_URL + 'customer/chat?vendor_id=' + self.seller.id;
                }
                return window.location = process.env.WEB_URL + 'customer/chat/buyer?vendor_id=' + self.seller.id;
            }else{
                window.location = 'login';
            }
        });
    }

    // REDIRECT TO MESSAGE PAGE IF LOGIN
    self.contactSeller = function (vendor_id) {
        return Server.getDataFromServer('/microsite/profile-chat/'+vendor_id)
        .then(function(response) {
            if(self.is_login){
                window.location = 'customer/chat/'+response.result.encoded_key;
            }else{
                window.location = 'login';
            }
        });
    };

    // show social media shares
    self.socialMediaShare = () => {
        self.socialMediaOptions = document.getElementById('social-media-options');
        if (self.socialMediaOptions.style.display === "none") {
            self.socialMediaOptions.style.display = "block";
        } else {
            self.socialMediaOptions.style.display = "none";
        }
    };

    /**
     * Show modal cart on click buy now
     * @param {String} itemID
     * @param {String} qty
     */
    self.modalCart = function (buynow) {
        if (!permissionService.hasPermission('website.cart_access')) return;
        var data = {
            product_quantity: parseInt(self.quantity, 10),
            item_id: parseInt(self.product.item.id),
            model: self.defaultModel,
            price_location_id: (self.itemLocation && self.location.status !== 'false') ? parseInt(self.itemLocation.priceLocations[self.product.price.index].id, 10) : null,
            location_id: (self.itemLocation && self.location.status !== 'false') ? parseInt(self.id_loc, 10) : null
        };

        if (!is_login) {
            window.localStorage.setItem('datacart', JSON.stringify(data));
            return window.location.href = '/login?source=buy-pdp';
        }

        self.quotation.listcart = [];
        self.purchaseError = false;
        data['campaign_id'] = cookiesCampaign();

        if (!buynow) angular.element('#modalcart').modal();

        self.loadingnow = true
        APIOrderSDKV2.addToCart(data.item_id, data.product_quantity, data.model, data.price_location_id, data.location_id)
          .then(function(response) {
            const atc_validation_result = response.data.result.atc_validation_result
            if (atc_validation_result.status === 'success') {
              const utmMedium = Path.getQueryUrl('utm_medium')
              googleAnalytics4.trackAddToCart(atc_validation_result.result, utmMedium)
              dataLayer.push({
                _products: atc_validation_result.result.analytics,
                event: 'addedToCart'
              });
              const cartDetail = response.data.result.detail
              const addedProductDetail = cartDetail.filter(function(el) {
                return el.details[0].id_item === atc_validation_result.result.analytics.productID
              })
              if (addedProductDetail && addedProductDetail.length &&
                addedProductDetail[0].details[0].stock_type === 'finite') {
                dataLayer.push({
                  etrkC: 'Buyer Action',
                  etrkA: 'Buyer Action - Add To Cart Product with Limited Stock',
                  etrkL: 'Add to Cart - Product with Limited Stock',
                  event: 'gaBehaviorEventCapture'
                })
              }
              if (!buynow) {
                APIOrderSDKV2.getCartItems()
                  .then(function(getCartResponse) {
                    const ATCGetCart = getCartResponse.data.result.atc_validation_result
                    if (ATCGetCart.status === "success") {
                        self.loadingnow = false
                        self.cart.luggages = getCartResponse.data.result.detail
                        $scope.$parent.home.getCart()

                        self.cart.luggages.forEach(function (value, key) {
                            value.details.forEach(function (v, k) {
                                if(v.campaign == null && v.stock_type === 'finite' && (v.available_stock < v.minimum_order || v.is_stock_available == 0 || v.available_stock == 0)) {
                                    v.alert_danger = true;
                                    APIOrderSDKV2.deleteCartItem(parseInt(v.id_item, 10)).then(function() {
                                        $scope.home.getCart();
                                    })
                                }
                                else if(v.campaign == null && v.stock_type === 'finite' && (v.is_stock_available == 1 && v.available_stock > 0 && v.product_quantity > v.available_stock))
                                {
                                    v.alert_stock = true;
                                    v.product_quantity = v.available_stock;
                                    APIOrderSDKV2.updateCartItem(v.id_item, v.product_quantity, v.price_location_id)
                                }
                            })
                        })
                        // $scope.$apply()
                    }
                  })
                  .catch(function(getCartError) {
                    growl.error(String(getCartError))
                  })
              } else {
                $scope.home.goto('order/checkout-combine');
              }
            } else {
              self.purchaseError = true;
              self.purchaseErrorMsg = atc_validation_result.message;
              self.loadingnow = false;
            }
          })
          .catch(function(err) {
            growl.error(String(err))
          })
    };

    self.url = function (link) {
        return url(link);
    };

    self.chatAll = function (vendorId) {
        return Server.getDataFromServer('/microsite/profile-chat/'+vendorId)
        .then(function(response) {
            if(self.is_login){
                window.location = 'customer/chat/'+response.result.encoded_key;
            }else{
                window.location = 'login';
            }
        });
    };


    /**
     * Set initial price and quantity based on the highest price available and minimum order allowed
     *  from the wholesale data
     */
    function calcInitPrice () {
        if(self.product.campaign){
            if(self.product.campaign.campaign_prices.length > 0){
                var prices = self.product.campaign.campaign_prices;
                self.product.availability.minimum_order = prices[0].quantity_start;
            }

            if(self.product.campaign.max_buy_qty >= self.product.availability.minimum_order && self.product.campaign.max_buy_qty != null){
                self.product.item.available_stock = self.product.campaign.max_buy_qty;
            }
        }

        self.product.price = {
            'stock': self.product.item.available_stock,
            'value': self.product.prices[0].discount ? self.product.prices[0].discount : self.product.prices[0].price,
            'original': self.product.prices[0].price,
            'index': null,
            'is_discount': false,
            'discount': 0
        };

        if (self.product.prices[0].discount) {
            self.product.price.is_discount = true;
            self.product.price.discount = self.product.prices[0].discount;
        }

        if (self.product.availability.is_campaign_available && self.product.campaign.campaign_prices.length > 0) {
            self.product.price.value = self.product.campaign.campaign_prices[0].price;
            self.product.price.stock = self.product.campaign.campaign_prices[0].quantity_left;
        }

        self.product.price.total = self.product.price.value * self.product.availability.minimum_order;
    }

    /**
     * Determine price according to quantity
     * @requires ItemQuantity
     */
    self.wholesaleCalc = function () {
        if(self.product.campaign !== null && parseInt(self.quantity) >= parseInt(self.product.campaign.max_buy_qty)) self.quantity = self.product.campaign.max_buy_qty;
        $timeout.cancel(self.quantity_update);
        self.quantity_update = $timeout(
            function () {
                self.quantity = ItemQuantity.checkValNew(self.product, self.quantity);
                doCalc();
            }, self.debounce
        );
        doCalc();
    };

    function doCalc () {
        var priceResult = ItemQuantity.wholesaleCalcNew(self.product, self.quantity, 'reverse');
        self.product.price.total = priceResult.price * self.quantity;
        self.product.price.value = priceResult.price;
        self.product.price.index = priceResult.index;
    }

    self.locationCalc = function () {
        self.quantity = ItemQuantity.checkValNew(self.product, self.quantity);
        self.product.price.shipping_price_est = self.itemLocation.estimateShippingPrice * self.quantity;
        self.product.price.totalByLocation = self.itemLocation.priceLocations[0].price * self.itemLocation.priceLocations[0].min_qty;
        self.product.price.grand_total_est_by_location = parseInt(self.product.price.shipping_price_est) + self.product.price.totalByLocation;
        var priceResult = ItemQuantity.wholesaleCalcNew(self.product, self.quantity, 'forward');
        self.product.price.value = parseInt(priceResult.price);
        self.product.price.total = parseInt(priceResult.price) * self.quantity;
        if (self.product.price.shipping_price_est !== 0) {
            self.product.price.grand_total_est = parseInt(self.product.price.shipping_price_est) + self.product.price.total;
        } else {
            self.product.price.grand_total_est = self.product.price.total;
        }
    };

    self.share = function (provider) {
        Socialshare.share({
            'provider': provider,
            'attrs': {
                'socialshareUrl': self.shareUrl,
                'socialsharePopupHeight': 500,
                'socialsharePopupWidth': 800,
                'socialshareText': self.socialItemDescription
            }
        });
    };

    self.specificCourierModal = {
        open() {
            angular.element('#list-specific-courier-modal').modal('show');
            dataLayer.push({ etrkC: 'PDP Free Shipping', etrkA: 'Learn more free shipping click', etrkL: '', event: 'gaBehaviorEventCapture' });
        },
        close() {
            angular.element('#list-specific-courier-modal').modal('hide');
            dataLayer.push({ etrkC: 'PDP Free Shipping', etrkA: 'Back click', etrkL: '', event: 'gaBehaviorEventCapture' });
        }
    };

    self.simulations.kredivo = null;
    function generateSimulation () {
        if (self.product.availability.minimum_order === 1 && self.product.prices[0].price > 1000000) {
            Server.posDataToServer('/items/kredivo-type', {
                item_id: self.product.item.id,
                item_price: self.product.price.total
            }).then(function (response) {
                if (response.status === 'OK') {
                    self.simulations.kredivo = $filter('orderBy')(response.payments, 'tenure');
                    if (self.simulations.kredivo.length > 1) {
                        self.simulations.kredivo[0] =
                            {
                                'tenure': 1,
                                'down_payment': self.simulations.kredivo[1].down_payment
                            };
                    } else {
                        delete self.simulations.kredivo;
                    }
                } else {
                    self.simulations.kredivo = null;
                }
            });
        }
    }


    self.openModalReportProduct = function (productId) {
        self.part = '';
        self.issue = '';
        self.comment = '';
        self.reportImage = [
            $translate.instant('image_not_match'),
            $translate.instant('image_offensive'),
            $translate.instant('image_addiotional'),
            $translate.instant('image_not_clear'),
            $translate.instant('other_issue')
        ];
        self.reportProduct = [
            $translate.instant('product_different'),
            $translate.instant('missing_info'),
            $translate.instant('product_unimportant'),
            $translate.instant('product_incorrect'),
            $translate.instant('other_issue')
        ];
        self.reportOther = [
            $translate.instant('other_product'),
            $translate.instant('price_issue'),
            $translate.instant('missing_info'),
            $translate.instant('shipping_issue'),
            $translate.instant('size_chart_issue'),
            $translate.instant('conflict_info'),
            $translate.instant('quality_issue'),
            $translate.instant('incorrect_info')
        ];

        $('#modalReportProduct').modal({
            'show': true,
            'backdrop': 'static',
            'keyboard': false
        });
        self.productId = productId;
    };

    self.getIssue = function (part) {
        if (part === 'image') {
            self.issueOption = self.reportImage;
        } else if (part === 'product_name') {
            self.issueOption = self.reportProduct;
        } else if (part === 'others') {
            self.issueOption = self.reportOther;
        }
    }

    self.submitReportProduct = function () {
        Server.posDataToServer('/product-report/submit-report', {
            page_section: self.part,
            issue: self.issue, productId: self.productId, comment: self.comment
        }).then(function (response) {
            if (response.status === 200) {
                $('#modalReportProduct').modal('hide');
                $('#modalReportSuccess').modal({
                    'show': true,
                    'backdrop': 'static',
                    'keyboard': false
                });
                $timeout(function () {
                    $('#modalReportSuccess').modal('hide');
                }, 3000);
            } else {
                self.report_message = response.message;
            }
        });

    };

    function redirectToLogin (path) {
        localStorage.setItem('lastpage', path);
        window.location = 'login';
    }

    function checkShowParam () {
        var qs = $location.search()
        if (qs.show_phone || qs.show_handphone || qs.show_email) {
            if (is_login) {
                if (qs.show_phone) {
                    self.showPhone = true;
                }
                if (qs.show_handphone) {
                    self.showHandphone = true;
                }
                if (qs.show_email) {
                    self.showEmail = true;
                }
            } else {
                redirectToLogin($location.path());
            }
        }
    }

    self.showContactDetail = function (type) {
        var path = $location.path() + '?show_' + type;
        if (is_login) {
            switch (type) {
                case 'phone':
                    self.showPhone = true
                    $location.search('show_phone', true);
                    break;
                case 'handphone':
                    self.showHandphone = true
                    $location.search('show_handphone', true);
                    break;
                case 'email':
                    self.showEmail = true
                    $location.search('show_email', true);
                    break;
            }
        } else {
            redirectToLogin($location.path());
        }
    }

    // carousel
    self.isGold = false;
    self.widthDesktop = 280;
    self.widthMobile = 340;
    self.widthZoom = 600;
    self.widthCurrent = self.widthDesktop;
    self.imageModel = [];

    $('#img-resp-carousel').attr('data-zoom-image', self.currentImage);

    function initZoom () {
        // init properties
        self.currentImage = self.product.default_image;
        self.imageModel = self.product.images;

        setTimeout(function () {
            imgPreviewResponsive();

            if ('screen' in window && window.screen.width > 800) {
                angular.element("#item-preview").hover(function () {
                    $(this).attr(
                      'data-zoom-image',
                      self.currentImage.url.replace(/\/\d+\//g, '/' + self.widthZoom + '/')
                    );
                    angular.element(this).ezPlus();
                });
            }
        }, 3000);
    }

    function imgPreviewResponsive () {
        if ($scope.home.screenType === 'mobile') {
            self.currentImage.url = self.currentImage.url.replace(/\/\d+\//g, '/' + self.widthMobile + '/');
            self.widthCurrent = self.widthMobile;
        } else {
            self.currentImage.url = self.currentImage.url.replace(/\/\d+\//g, '/' + self.widthDesktop + '/');
            self.widthCurrent = self.widthDesktop;
        }
    }

    // Detect screen type, desktop or mobile
    $scope.$watch('home.screenType', function () {
        imgPreviewResponsive();
    }, true);

    self.doChangeImage = function (imageSrc) {
        self.currentImage = imageSrc;
        angular.element('.zoomWindow').css(
            'background-image',
            'url(' + imageSrc.url.replace(/\/\d+\//g, '/' + self.widthZoom + '/') + ')'
        );

        imgPreviewResponsive();
    }

    // To PDP page
    self.goToPdp = function (vendor_alias, alias) {
        window.location = base_path + '/v/' + vendor_alias + '/product/' + alias;
    }

    $scope.openVideo = function (url) {
        document.querySelector('#ytplayer').src = url;
    };

    $scope.closeVideo = function () {
        document.querySelector('#ytplayer').src = '';
    };

    self.imagePreview = function (imgUrl) {
        self.imgPreview = imgUrl;
        $('#modalImagePreview').modal('show');
    };

    //RFQ Widget begin


    self.minusQty = function (min) {
        self.rfq.quantity = parseInt(self.rfq.quantity) || parseInt(min);
        if (self.rfq.quantity <= min) return;
        self.rfq.quantity--;
    };

    self.plusQty = function (max) {
        self.rfq.quantity = parseInt(self.rfq.quantity) || parseInt(max);
        if (self.rfq.quantity >= max) return;
        self.rfq.quantity++;
    };

    self.rfq = {};

    $scope.form = {};
    $scope.form.unit = 'Unit';

    self.hide = {};
    self.hide.rfqwidget = true;
    self.offsetRfqWidget = 600;

    self.cleanRFQForm = function () {
        if (self.rfq.description) {
            self.rfq.description = self.rfq.description.replace(/^ +/g, '').replace(/  +/g, ' ');
        }
    };

    self.getLocation = function (location) {
        $scope.home.isLoading = true;
        return Server.getDataFromServer('/items/location-available?like=' + location)
            .then(function (data) {
                $scope.home.isLoading = false;
                if (data !== null) {
                    self.locationAvailable = data.result;
                    return data.result;
                }
            })
    }

    self.getItemPriceLocation = function (id_loc, item_id) {
        self.id_loc = id_loc;
        $scope.home.isLoading = true;
        Server.getDataFromServer('/items/price-by-location?subdistrict_id=' + id_loc + '&item_id=' + item_id)
            .then(function (response) {
                if (response.status !== false) {
                    self.itemLocation = response.data;
                    $scope.home.isLoading = false;
                    self.locationCalc();
                } else {
                    $scope.home.isLoading = false;
                    self.itemLocation = response;
                }
            });
    }

    function getAddressDetail () {
        Server.getDataFromServer('/items/address-detail?subdistrict_id=' + self.sub_district_id)
            .then(function (response) {
                self.location = response.result[0].keterangan;
            });
    }

    function checkItemLocationCart () {
        angular.forEach($scope.home.homecart, function (value, key) {
            for (var i = 0; i < value.length; i++) {
                if (value[i].location_id && value[i].location_id !== '0') {
                    self.sub_district_id = value[i].location_id;
                }
                break;
            }
        });
        if (self.sub_district_id) {
            getAddressDetail();
            self.getItemPriceLocation(self.sub_district_id, self.product.item.id);
        } else {
            self.isDisabled = false;
        }
    }

    function cookiesCampaign () {
        self.cookieCampaignId = Cookie.getCookie('campaign');
        if(self.cookieCampaignId != undefined){
            return self.cookieCampaignId.split(",");
        }
        return [];
    }

    angular.element($window).bind("scroll", function () {
        self.hide.rfqwidget = $window.pageYOffset <= self.offsetRfqWidget;
    });

    var phone = document.getElementById('rfq_widget_phone');
    if (phone) {
        phone.addEventListener("invalid", function (event) {
            if (phone.validity.rangeUnderflow) {
                phone.setCustomValidity("Phone number minimal length is 7");
            } else {
                phone.setCustomValidity("");
            }
        });
    }

    if (self.is_login) {
        Server
            .getDataFromServer('/customer/addresses')
            .then(function (response) {
                if (
                    response.status === 'success' &&
                    response.result &&
                    response.result.main
                ) {
                    var mainAddress = response.result.main;
                }
            });
    }
}]);
